import { CUSTOMER_DETAILS_DEFAULTS } from '@/utils/defaults';
import CreateCustomerModal from '@/pages/Customer/Modals/CreateCustomerModal';

export const CustomerMixin = {
    methods: {
        /**
         *
         * @param {number} teamRegionId
         * @returns {Promise<Object>} - Returns default values from customer
         */
        async $_customerMixin_createCustomer(teamRegionId) {
            const customerDetails = { ...CUSTOMER_DETAILS_DEFAULTS(), teamRegionId };
            const result = await this.$modal.showWithoutAutoClose(CreateCustomerModal, {
                customerDetails,
                version: 'v2'
            });
            if (result.status !== 'ok') {
                return {};
            }
            const { customerId, customerDetails: newCustomerDetails } = result.result;
            const defaultDetails = this.$_customerMixin_setDetailsFromCustomer(customerId, newCustomerDetails);
            return defaultDetails;
        },
        async $_customerMixin_setDetailsFromCustomer(customerId, data) {
            const name = [];
            if (data.firstName) {
                name.push(data.firstName);
            }
            if (data.lastName) {
                name.push(data.lastName);
            }

            const result = {
                customerId,
                contact: {
                    name: name.join(' ').trim(),
                    phone: data.phone,
                    email: data.email
                },
                notes: data.defaultStopNotes,
                customerName: data.name
            };
            if (data.brandId) {
                result.brandId = data.brandId;
            }
            if (data.defaultRateGroupId) {
                result.rateGroupId = data.defaultRateGroupId;
            }
            if (data.address) {
                result.address = data.address;
                result.addressComponents = data.addressComponents;
                result.location = data.location;
            }
            return result;
        }
    }
};
